import { createContext, useContext } from "react";

const NewValueContext = createContext();

const useNewValue = () => useContext(NewValueContext);

export { NewValueContext, useNewValue };